import { observable } from "@legendapp/state";

import { activeOrganization$ } from "../organizations";

export const invitations$ = observable(
  () =>
    activeOrganization$.invitations
      .get()
      ?.filter((inv) => inv.status === "pending") ?? [],
);
